<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { show_message } from '../../lib/flash.ts';
  import ClaimMachiine from '../claim-machine.js';
  import InputWithValidation from '../../lib/components/InputField.svelte';

  export let id;
  export let main;
  export let context;

  let wait_api = false;
  let machine = new ClaimMachiine({ id, main, context });
  let value_field;
  context = machine.context;

  $: {
    machine.update_context(context);
    context = machine.context;
  }

  let dispatch = createEventDispatcher();

  const submit_claim = async () => {
    wait_api = true;
    let result = await machine.claim();
    wait_api = false;
    if (result) {
      show_message(context.success_text, 'success');
    }
  };

  const init = () => {
    // value_field.focus();
  };

  onMount(init);
</script>

<div>
  <div class="content">
    <div class="fade-in">
      <InputWithValidation
        bind:this={value_field}
        bind:value={context.invitation_code}
        id="claim-description"
        type="text"
        label={context.invitation_code_label}
        name="invitation_code"
        validate={false}
        validation_text="claim"
        valid={true}
        is_tooltip_default={true}
        tooltip_default_text="{context.explanation_1}
        {context.explanation_2}"
        width="410px" />

      <input
        id="claim_pp"
        type="submit"
        class="mdc-button mdc-button--unelevated margin-5"
        value={context.processing ? context.processing_text : context.claim_label}
        disabled={!context.invitation_code || wait_api}
        on:click|preventDefault={async () => { await submit_claim() } } />

      <span class="total" class:hidden={!context.valid}>
        {context.total_text}
      </span>

      <img
        id="claim_pp_loader"
        src="/assets/spinners/orderer_loader.gif"
        alt="Loading"
        style="display: none" />
    </div>

    <div class="margin">
      <InputWithValidation
        id="claim-pp-amount"
        variant={'filled'}
        margin_bottom={'1px'}
        type="text"
        label={context.your_pp_label}
        name="pp-amount"
        bind:value={context.amount_text}
        width='100%' />
    </div>
  </div>
</div>
<!-- end of fieldset Claim -->

<style>
  #claim_pp:disabled {
    color: darkgrey;
  }

  .content {
    margin-bottom: 50px;
    margin-top: 60px;
    justify-content: center;
    display: flex;
  }

  .margin {
    margin-left: 10px;
  }
</style>
